import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { fonts, colors } from "../../../styles/variables";

const Container = styled.div`
  height: 100%;
  width: calc(100% + 40px); /* Hides the X button in alert. */
  background-color: transparent;
  align-items: flex-start;
  justify-content: center;
  cursor: default;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0.7;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${colors.warning};
  padding-right: 5px;
  flex: 0.3;
`;

const MessageContent = styled.span`
  cursor: default;
`;

const ClickableMessageContent = styled(MessageContent)`
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 1.4px;
`;

const CustomAlertWithActionButton = ({
  message,
  messageWithURL,
  onMessageWithURLClick = () => {},
  actionButtonCopy,
  onActionButtonClick = () => {},
}) => (
  <Container>
    <MessageContainer>
      <MessageContent>
        {message}
        <ClickableMessageContent onClick={() => onMessageWithURLClick()}>
          {messageWithURL}
        </ClickableMessageContent>
      </MessageContent>
    </MessageContainer>
    <ActionContainer>
      <ClickableMessageContent onClick={() => onActionButtonClick()}>
        {actionButtonCopy}
      </ClickableMessageContent>
    </ActionContainer>
  </Container>
);

CustomAlertWithActionButton.propTypes = {
  message: PropTypes.string.isRequired,
  messageWithURL: PropTypes.string.isRequired,
  onMessageWithURLClick: PropTypes.func,
  actionButtonCopy: PropTypes.string.isRequired,
  onActionButtonClick: PropTypes.func,
};

export default CustomAlertWithActionButton;
